<template>
  <div class="p-5">
    <h4 class="text-h4 mb-4">
      Ícones
    </h4>
    <hr />
    <CRow>
      <CCol class="my-4" sm="1" v-for="(icon, index) in iconsList" :key="index">
        <div class="text-center mb-2">
          <CIcon :name="icon" size="custom-size" :height="25" viewBox="0 0 32 32" />
        </div>
        <div class="text-center titulo-icon " style="cursor: pointer;" @click="copiarNome(icon)">
          {{ icon }}
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { iconsSet } from '../assets/icons/icons.js'

export default {
  data() {
    return {
      iconsList: [],
    }
  },
  mounted() {
    this.iconsList = Object.keys(iconsSet)
  },
  methods: {
    copiarNome(icon) {
      let component = `<CIcon
              name="${icon}"  
              size="custom-size"
              :height="14"
              viewBox="0 0 32 32"/>`

      let element = document.createElement('textarea')
      element.value = component

      document.body.appendChild(element)

      element.focus()
      element.select()

      document.execCommand('copy')

      document.body.removeChild(element)
    },
  },
}
</script>

<style lang="scss">
.titulo-icon {
  &:hover {
    color: green;
    font-weight: 900;
  }
}
</style>
